const mediaItems = [
  {
    title: '探花精选 · 本周热门合集预览',
    desc: '本周最受关注的探花在线精选内容概览',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20golden%20amber%20abstract%20composition%20with%20soft%20flowing%20motion%2C%20elegant%20curves%20and%20gradients%2C%20rich%20atmospheric%20lighting%2C%20premium%20media%20card%20aesthetic%2C%20dark%20warm%20background%20with%20golden%20highlights%2C%20no%20text%2C%20no%20people%2C%20abstract%20art&width=800&height=500&seq=media-tanhua-weekly&orientation=landscape',
    duration: '42:18',
    views: '12.8w',
  },
  {
    title: '经典回顾 · 探花珍藏版精选',
    desc: '探花经典内容回顾，重温那些精彩瞬间',
    img: 'https://readdy.ai/api/search-image?query=Rich%20burgundy%20and%20dark%20amber%20abstract%20cinematic%20scene%2C%20dramatic%20lighting%20with%20soft%20focus%20effects%2C%20elegant%20velvet%20textures%20with%20golden%20rim%20light%2C%20premium%20movie%20poster%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20fine%20art%20style&width=800&height=500&seq=media-tanhua-classic-preview&orientation=landscape',
    duration: '58:33',
    views: '9.5w',
  },
  {
    title: '最新探花 · 新晋内容速览',
    desc: '最新上架的探花在线资源抢先预览',
    img: 'https://readdy.ai/api/search-image?query=Fresh%20coral%20and%20soft%20rose%20gold%20abstract%20cinematic%20composition%2C%20gentle%20flowing%20light%20streaks%2C%20modern%20elegant%20aesthetic%2C%20warm%20atmospheric%20gradients%2C%20premium%20clean%20look%2C%20no%20text%2C%20no%20people%2C%20abstract%20art&width=800&height=500&seq=media-tanhua-latest&orientation=landscape',
    duration: '35:47',
    views: '6.9w',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
            精彩预览
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item) => (
              <a
                key={item.title}
                href="#media"
                onClick={(e) => e.preventDefault()}
                className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-primary-300 transition-all duration-200 cursor-pointer group"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                      <i className="ri-play-fill text-xl text-accent-600 ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-0.5 text-[10px] font-medium text-white bg-black/60 rounded whitespace-nowrap">{item.duration}</span>
                </div>
                <div className="p-4">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                  <p className="text-xs text-foreground-400">{item.views} 次浏览</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}